import { render, staticRenderFns } from "./KernelPressSheetOrderItemsList.vue?vue&type=template&id=52dae3a1&"
import script from "./KernelPressSheetOrderItemsList.vue?vue&type=script&lang=js&"
export * from "./KernelPressSheetOrderItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports